












































































import { Component, Vue, Inject, InjectReactive } from 'vue-property-decorator'
import { EnviromentModel } from '@/_models/EnviromentModel'

@Component({})
export default class IndoorSettingButton extends Vue {
  @InjectReactive('indoor-env-info-display')
  envInfoDisplays!: any
  @InjectReactive('indoor-beacon-animation')
  beaconAnimation!: boolean

  @InjectReactive('indoor-env-info-display-setting')
  envInfoDisplaySetting!: boolean

  @InjectReactive('indoor-beacon-setting-loading')
  beaconSettingLoading!: boolean

  @InjectReactive('indoor-filter-env-items')
  filteredEnvItems!: EnviromentModel[]

  @InjectReactive('indoor-tracking-user-name')
  trackingUserName!: string

  @Inject('indoor-update-beacon-animation')
  updateBeaconAnimation!: () => void

  @Inject('indoor-change-env-display-setting')
  updateEnvInfoDisplaySetting!: () => void

  @Inject('indoor-toggle-env-display')
  onToggleEnvDisplay!: (envDevice: EnviromentModel) => void

  @Inject('indoor-on-mouse-enter')
  onMouseEnter!: (envDevide: EnviromentModel) => void

  @Inject('indoor-open-tracking-modal')
  openTrackingHistory!: () => void
}
